import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=276338f1&scoped=true&"
import script from "./certification.vue?vue&type=script&lang=ts&"
export * from "./certification.vue?vue&type=script&lang=ts&"
import style0 from "./certification.vue?vue&type=style&index=0&id=276338f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276338f1",
  null
  
)

export default component.exports